import modelBase from "../model-base.model";
import modelBaseV2 from "../model-base-v2.model"
import moment from "moment";
import { formats as FORMATS } from '../../config/constants';

const teamScheduleModel = {

    getTeamScheduleList: function (successCallBack, failureCallBack, filter) {
        const qs = modelBase.toQueryString(filter);
        modelBase.get(successCallBack, failureCallBack, '/api/schedule?' + qs);
    },

    getScheduleVisitSummary: function (successCallBack, failureCallBack, filter) {
        const qs = modelBase.toQueryString(filter);
        modelBase.get(successCallBack, failureCallBack, '/api/schedule/visitSummaryRate?' + qs);
    },

    uploadCreditCardInstallmentMasterExcel: function (successCallBack, failureCallBack, formData) {
        modelBase.post(successCallBack, failureCallBack, '/api/bankinstallment/upload', { body: formData });
    },

    getScheduleDetails: function (successCallBack, failureCallBack, filter) {
        const qs = modelBase.toQueryString(filter);
        modelBase.get(successCallBack, failureCallBack, '/api/schedule/mySchedule?' + qs);
    },

    transformTeamScheduleObj: function (scheduleList, selectedDays) {
        const colSize = selectedDays ? selectedDays.length : 0;
        let scheduleTable = [];
        let userRows = new Map();

        scheduleList.map(i => {
            // Check if a row for the user ID already exists
            let scheduleRow = userRows.get(i.userID);
            if (!scheduleRow) {
                // If no row exists, create a new row
                scheduleRow = {};
                scheduleRow.dateCols = new Array(colSize);
                scheduleRow.dateCols.fill(); // Initialize with undefined value

                // Set the user info for the new row
                scheduleRow.userID = i.userID;
                scheduleRow.userName = i.userName;
                scheduleRow.photoString = i.photoString;

                // Add the new row to the map and the table
                userRows.set(i.userID, scheduleRow);
                scheduleTable.push(scheduleRow);
            }

            if (!i.scheduleID || i.scheduleID === '00000000-0000-0000-0000-000000000000') {
                return;
            }
            // Set schedule info to scheduleItem
            let scheduleItem = { ...i };

            // Assign scheduleItem to the correct column/date
            let colIndex = selectedDays.findIndex(e => moment(e).format(FORMATS.dateFormat) === moment(i.scheduleDate).format(FORMATS.dateFormat));
            if (colIndex > -1) {
                if (scheduleRow.dateCols[colIndex] === undefined) {
                    scheduleRow.dateCols[colIndex] = new Array();
                }
                scheduleRow.dateCols[colIndex].push(scheduleItem);
            }
        });
        return scheduleTable;
    },

    downloadTeamScheduleExcel: function (filter, fileName = `Team Schedule - ${moment().format('YYYYMMDDHHmm')}.xlsx`) {
        let params = {};
        params.sortBy = "";
        params.orderBy = "";
        params.pageIndex = 0;
        params.pageSize = 0;
        params.storedProcedureCode = "79";
        params.params = [
            { code: "7", value: filter.inputUserID },
            { code: "8", value: moment(filter.fromDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat) }, // FromDate
            { code: "9", value: moment(filter.toDate, FORMATS.dateFormat).format(FORMATS.apiDateFormat) }, // ToDate
            { code: "16", value: filter.inputCountryCode },
            { code: "17", value: filter.inputUserLanguageCode },
            { code: "165", value: filter.workTypes }, // WorkType
            { code: "32", value: "" }, // UserIDs
            { code: "31", value: "" }, // SiteIDs
            { code: "164", value: "1" }
        ];
        params.excelSheetNames = ["Team Schedule", "Total Count"];

        return modelBaseV2.postDownload('/api/retail/file/export/tr/file', { body: params }, fileName);
    },
    getLatestJPOSchedule: function (successCallBack, failureCallBack, filter) {
        const qs = modelBase.toQueryString(filter);
        modelBase.get(successCallBack, failureCallBack, '/api/schedule/updated' + qs);
    },
    markScheduleSent: function (successCallBack, failureCallBack, params) {
        modelBase.post(successCallBack, failureCallBack, '/api/schedule/updated', { body: params });
    },
}

export default teamScheduleModel;

const workType = {
    WORK_TYPES: [
        { code: '001', name: 'Work', color: '#1E85F1' },
        { code: '002', name: 'Leave', color: '#BD35BD' },
        { code: '003', name: 'Day Off', color: '#3BE282' },
        { code: '004', name: 'Training', color: '#FFE654' },
        { code: '005', name: 'Roadshow', color: '#9DE7DA' },
        { code: '006', name: 'Others', color: '#0B7477' },
        { code: '007', name: 'Special Task', color: '#8000FF' },
    ],

    getColor: function (workTypeCode, defaultColor = null) {
        var colorCode = defaultColor;
        var workType = this.WORK_TYPES.find(e => e.code === workTypeCode);

        if (workType) {
            colorCode = workType.color;
        }
        return colorCode;
    }
}

export { workType };
